export const AI_VIEW_CONTEXT_SCHEMA_VERSION = "1.0" as const;
export const AI_VIEW_NAME_DASHBOARD = "Dashboard" as const;
export const AI_VIEW_MODE_READ = "read" as const;

export interface AIViewIdentity {
  name: string;
  mode: typeof AI_VIEW_MODE_READ;
  recordId?: string;
  title?: string;
}

export interface AIViewContext<TData = unknown> {
  schemaVersion: typeof AI_VIEW_CONTEXT_SCHEMA_VERSION;
  view: AIViewIdentity;
  filters: Record<string, unknown>;
  data: TData;
  capturedAt: number;
}

export interface DashboardAIContext {
  dashboardId: string;
  dashboardName: string;
  sections: DashboardAISection[];
}

export interface DashboardAISection {
  id?: string;
  name: string;
  charts: DashboardAIChart[];
  indicators: DashboardAIIndicator[];
}

export interface DashboardAIChart {
  id?: string;
  name: string;
  type: string;
  collection?: string;
  groupBy?: string[];
  labels: string[];
  values: Array<string | number>;
  groups: DashboardAIGroup[];
  series?: DashboardAISeries[];
}

export interface DashboardAISeries {
  name: string;
  values: Array<string | number>;
}

export interface DashboardAIGroup {
  label: string;
  value: string | number;
  percentage?: number;
}

export interface DashboardAIIndicator {
  id?: string;
  name: string;
  value: string | number;
  unit?: string;
}

export type DashboardAIViewContext = AIViewContext<DashboardAIContext>;

export interface ChatContext {
  activeViewContext?: AIViewContext;
  userData?: unknown;
  serviceId?: string;
  documentId?: string;
  [key: string]: unknown;
}
